import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    background: {
      paper: "rgba(0, 0, 0, 1)",
      default: "rgba(25, 20, 20, 1)",
    },
    primary: {
      light: "rgba(98, 236, 131, 1)",
      main: "rgba(29, 185, 84, 1)",
      dark: "rgba(0, 136, 39, 1)",
      contrastText: "rgba(255, 255, 255, 1)",
    },
    secondary: {
      light: "#2b2b2b",
      main: "#191414",
      dark: "#110e0e",
      contrastText: "#fff",
    },
    text: {
      primary: "rgba(255, 255, 255, 1)",
      secondary: "rgba(179, 179, 179, 1)",
    },
  },
  typography: {
    fontFamily: ["sans-serif", '"Helvetica Neue"', "Helvetica", "Arial"].join(
      ","
    ),
  },
});

export default theme;
